import CalendarPrintDialogBase from './CalendarPrintDialog.base';
import type {
    CalendarPrintDialogProps,
    CalendarPrintHandle,
    CalendarPrintDialogStyleProps,
    CalendarPrintDialogStyles,
} from './CalendarPrintDialog.types';
import { styled } from '@fluentui/react/lib/Utilities';
import { SurfaceConstants } from 'owa-calendar-surface-core';
import { getPalette } from 'owa-theme';
export type { CalendarPrintDialogProps };

/** The default style of CalendarPrintDialog */
export function getStyles(styleProps: CalendarPrintDialogStyleProps): CalendarPrintDialogStyles {
    let themeSymbols = getPalette();
    return {
        root: [
            'ms-CalendarPrintDialog',
            {
                display: 'flex',
                flexFlow: 'row',
                height: '100%',
                width: '100%',
            },
            styleProps.className,
        ],
        settingsPane: {
            paddingBottom: 10,
        },
        previewPane: {
            flexGrow: 1,
        },
        positionPreview: {
            alignItems: 'center',
            backgroundColor: themeSymbols.neutralLighter,
        },
        paddingForPreview: {
            // Due to how firefox handles height and width of a transformed element
            // need to hardcode the centering of printPreview.
            paddingLeft: '22%',
        },
        settingsContainer: {
            padding: '10px 20px 20px',
            maxWidth: '300px',
        },
        actionButtons: {
            marginRight: 20,
        },
        container: {
            width: '100%',
            backgroundColor: themeSymbols.neutralLighter,
        },
        printTitle: {
            fontSize: 21,
            fontWeight: 600,
            paddingBottom: 15,
        },
        closeButtonContainer: {
            height: 50,
            minWidth: SurfaceConstants.printPreviewMinPaneWidth,
            backgroundColor: themeSymbols.neutralLighter,
        },
        closeButton: {
            float: 'right',
            position: 'relative',
            top: 12,
            right: 25,
        },
    };
}

/** The default styled version of CalendarPrintDialog */
export const CalendarPrintDialog = styled<
    CalendarPrintDialogProps<{}>,
    CalendarPrintDialogStyleProps,
    CalendarPrintDialogStyles
>(CalendarPrintDialogBase, getStyles) as <TEvent>(
    props: CalendarPrintDialogProps<TEvent> & { ref?: React.Ref<CalendarPrintHandle> }
) => JSX.Element;
